import script from "./Sub3.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub3.vue?vue&type=script&setup=true&lang=ts"

import "./Sub3.vue?vue&type=style&index=0&id=ef7b7b3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef7b7b3c"]])

export default __exports__